import { ICON_BASE_PATH } from "@/app/utils/config";


export function LogoSmall() {
  return (
    <img
      src={`${ICON_BASE_PATH}logo-growx.svg`}
      alt="Logo"
    />
  );
}
